import React, { useCallback, useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"

import { isMobile, treeMethods } from "utils"
import FoodCategoriesChip from "./FoodCategoriesChip"
import classes from "./index.module.scss"

const FoodsCategories = () => {
  const combos =
    useSelector(state => state.combos)

  const categories =
    useSelector(state => state.categories)

  const branchId =
    useSelector(state => state.userAccountInfo.branchId)

  const [isDragging, setIsDragging] = useState(false)

  const ref = useRef(null)
  const scrollLeft = useRef(0)
  const timeout = useRef()
  const shift = useRef({ x: 0, y: 0 })

  const handleScrollToSection = (category) => {
    if (isDragging) return

    const sectionElement =
      document.getElementById(category._id)

    if (!sectionElement) return

    sectionElement.scrollIntoView()
  }

  const handleMouseMove =
    useCallback((event) => {
      const x = -(event.clientX - shift.current.x)

      ref.current.scrollTo &&
        ref.current.scrollTo({
          left: x + scrollLeft.current,
          top: 0
        })

      setIsDragging(true)
    }, [])

  const handleMouseUp =
    useCallback(() => {
      clearTimeout(timeout.current)

      timeout.current =
        setTimeout(() => setIsDragging(false), 100)

      window.removeEventListener("mousemove", handleMouseMove)

      window.removeEventListener("mouseup", handleMouseUp)
    }, [])

  const handleMouseDown =
    useCallback((event) => {
      if (!!isMobile()) return

      shift.current.x = event.clientX

      shift.current.y = 0

      scrollLeft.current = ref.current.scrollLeft | 0

      window.addEventListener("mousemove", handleMouseMove)

      window.addEventListener("mouseup", handleMouseUp)
    }, [])

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current)

      window.removeEventListener("mousemove", handleMouseMove)

      window.removeEventListener("mouseup", handleMouseUp)
    }
  }, [])

  const thisBranchCategories =
    categories
      .sort((a, b) => a.order - b.order)
      .filter(cat =>
        cat.branchIds.includes(branchId)
      )

  const comboCategory = {
    _id: "Combos",
    name: "بسته های ترکیبی",
    image: "/assets/images/combo.png"
  }

  const haveCombo = combos.length > 0

  const data =
    haveCombo
      ? [comboCategory, ...thisBranchCategories]
      : thisBranchCategories

  const tree =
    treeMethods.arrayToTree(data)

  return (
    <div
      ref={ref}
      onMouseDown={handleMouseDown}
      className={classes["list"]}
    >
      {tree.map(category =>
        <FoodCategoriesChip
          key={category._id}
          category={category}
          isDragging={isDragging}
          onSelect={handleScrollToSection}
        />
      )}
    </div>
  )
}

export default React.memo(FoodsCategories)